import React from 'react';
import PropTypes from 'prop-types';
import { Spacer } from '@tfecom-thermofisher/react-komodo-design';

import { Button } from 'src/core/components';
import messages from 'src/components/EditSequence/messages';

import './EditPageActions.style.scss';

const EditPageActions = ({
  onCancel,
  onSubmit,
  canSubmit,
  enableActionButtons = true
}) => (
  <>
    <Spacer top="40" />
    <div className="edit-plate-actions" data-testid="plate-wells-form-buttons">
      <Button
        data-testid="cancel-edit-btn"
        type="outline"
        onClick={onCancel}
        label={messages.cancel}
        disabled={!enableActionButtons}
      />

      <Button
        data-testid="save-changes-btn"
        type="primary"
        onClick={onSubmit}
        label={messages.saveChanges}
        disabled={!enableActionButtons || !canSubmit}
      />
    </div>
  </>
);

EditPageActions.propTypes = {
  canSubmit: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  enableActionButtons: PropTypes.bool
};

export default EditPageActions;
